export default __webpack_public_path__ + "static/media/img-goals_1.9579b1eb.svg";